<template>
  <div class="cancel-page">

    <div class="card">

      <div class="icon">❌</div>

      <h1>Payment Cancelled</h1>

      <p class="subtitle">
        No worries — your payment was not completed.
      </p>

      <div class="details">
        <p>You can try again anytime. Your AI receptionist is ready when you are.</p>
      </div>

      <div class="actions">
        <button class="primary-btn" @click="retryPayment">
          Try Again
        </button>

        <button class="secondary-btn" @click="goHome">
          Back to Home
        </button>
      </div>

      <p class="small">
        Need help? contact@nocodeagent.ai
      </p>

    </div>

  </div>
</template>

<script>
export default {
  methods: {
    retryPayment() {
      // 👉 adapte vers ta page paiement
      window.location.href = "/#paiement";
    },

    goHome() {
      window.location.href = "/";
    }
  }
};
</script>

<style scoped>
.cancel-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  font-family: Inter, sans-serif;
}

.card {
  background: white;
  padding: 50px;
  border-radius: 20px;
  text-align: center;
  width: 420px;
  box-shadow: 0 30px 80px rgba(0,0,0,0.15);
}

.icon {
  font-size: 60px;
  margin-bottom: 20px;
}

h1 {
  font-size: 2rem;
  margin-bottom: 15px;
}

.subtitle {
  color: #6b7280;
  margin-bottom: 20px;
}

.details {
  margin-bottom: 30px;
  color: #374151;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.primary-btn {
  background: #2563eb;
  color: white;
  padding: 12px 24px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
}

.primary-btn:hover {
  background: #1d4ed8;
}

.secondary-btn {
  background: #e5e7eb;
  color: #111;
  padding: 12px 24px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
}

.secondary-btn:hover {
  background: #d1d5db;
}

.small {
  font-size: 0.85rem;
  color: #9ca3af;
}
</style>